/**
 * 모달 공통 스크롤 락.
 *
 * body 를 position:fixed 로 띄우면 문서 높이가 무너져(20000px → 뷰포트 높이) 브라우저가
 * 스크롤을 0 으로 버립니다. top:-저장위치 로 보정해 화면은 그대로 보이지만,
 * 해제할 때 반드시 저장해 둔 위치로 되돌려 놓아야 합니다.
 *
 * 예전 구현이 스크롤을 최상단으로 튕긴 이유 3가지를 모두 여기서 막습니다.
 *  1. 복원 위치를 body.style.top 에서 parseInt 로 되읽음 → 소수점이 잘림.
 *  2. 잠긴 상태에서 또 잠그면 window.scrollY 가 0 이라 top:-0px 로 덮여 위치를 잃음.
 *  3. GlobalStyle 의 scroll-behavior:smooth 때문에 복원이 애니메이션으로 처리됨
 *     → 최상단에서 원래 자리까지 수 초에 걸쳐 되돌아가는 것이 그대로 보임.
 */

let locked = false;
let savedY = 0;

export const scrollLock = () => {
  if (locked) return;

  locked = true;
  savedY = window.scrollY;
  document.body.style.cssText = `position:fixed;top:-${savedY}px;left:0;width:100%;overflow-y:scroll;`;
};

export const scrollUnlock = () => {
  if (!locked) return;

  locked = false;
  document.body.style.cssText = '';

  // 복원은 즉시 이동이어야 합니다. 인라인 스타일로 smooth 를 잠깐 끕니다.
  const html = document.documentElement;
  const prev = html.style.scrollBehavior;

  html.style.scrollBehavior = 'auto';
  window.scrollTo(0, savedY);
  html.style.scrollBehavior = prev;
};
